import moment from 'moment';

export const isEndingSoon = (endingSoon?: string | null, entryEnd?: string | null): boolean =>
  !!endingSoon && !!entryEnd && moment(endingSoon).isBefore(moment()) && moment(entryEnd).isAfter(moment());

export const isEnded = (end?: string | null): boolean => !!end && moment(end).isBefore(moment());
